import React, { Component } from "react";
import FormStep from "../../common/components/formStep";
import RadioForm from "../../common/components/html/radioForm";
import HdfcHeader from "../../common/components/pageBlocks/hdfcHeader";
import ModalPopUp from "../../common/components/pageBlocks/modalPopUp";
import IAgreeEMIRepayment from "../../common/components/pageBlocks/eMandate/iAgreeEMIRepayment";
import IAgreeSecurityMandate from "../../common/components/pageBlocks/eMandate/iAgreeSecurityMandate";
import commonContext, { AppContext } from "../../common/context/common";
import { leadType } from "../../app";
import { ALDDApis } from "../apis/aLDDApis";
import { Authorization } from "../../common/utils/authorization";

interface IProps {
    history: any;
}
interface IState {
    IAgreeTermIssue: boolean;
    IAgreeTerm: boolean;
    iAgreeEMIRepaymentSwitch: boolean;
    iAgreeEMIRepayment: boolean;
    iAgreeSecurityMandateSwitch: boolean;
    iAgreeSecurityMandate: boolean;
    iAgreeEMIRepaymentError: boolean;
    iAgreeSecurityMandateError: boolean;
}
export class EMandate extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    setLead: Function;
    apis: ALDDApis;
    formRef: any;
    authKeeper: Authorization;
    steps = [
        { title: "Vehicle" },
        { title: "Loan" },
        { title: "Personal" },
        { title: "e-Mandate", active: true },
        { title: "Confirmation" },
    ];
    constructor(props: IProps) {
        super(props);
        this.state = {
            IAgreeTerm: false,
            IAgreeTermIssue: false,
            iAgreeEMIRepaymentSwitch: false,
            iAgreeEMIRepayment: false,
            iAgreeSecurityMandateSwitch: false,
            iAgreeSecurityMandate: false,
            iAgreeEMIRepaymentError: false,
            iAgreeSecurityMandateError: false,
        };
        this.formRef = React.createRef();
    }
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.lead = (this.context as AppContext).lead as leadType;
        this.setLead = (this.context as AppContext).setLead;
        this.apis = (this.context as AppContext).apis as ALDDApis;

        const apiData = await this.apis.getEmandateOptions(this.lead);
        if (!apiData.error?.error) {
            this.setLead({ ...apiData.result });
        }
    }
    handleOnSubmit = async (e) => {
        e.preventDefault();
        this.lead = (this.context as AppContext).lead as leadType;
        this.setState({
            iAgreeEMIRepaymentError: false,
            iAgreeSecurityMandateError: false,
        });
        if (!this.state.iAgreeEMIRepayment) {
            return this.setState({ iAgreeEMIRepaymentError: true });
        }
        if (!this.state.iAgreeSecurityMandate) {
            return this.setState({ iAgreeSecurityMandateError: true });
        }
        // e.currentTarget.submit();
        const apiData = await this.apis.saveEmandateChannelAndCount(this.lead);
        if (!apiData.error?.error) {
            const apiDataUpdateEmandate = await this.apis.updateEmandateResponseAndCount(
                {
                    ...this.lead,
                    eMandateChannel: this.lead.emandateChannel,
                    eMandateStatus: "success",
                }
            );
            const apiDataUpdateSecEmandate = await this.apis.updateSecEmandateResponseAndCount(
                {
                    ...this.lead,
                    eMandateSecStatus: true,
                    eMandateSecUrn: this.lead.secMandateUrn,
                }
            );

            if (
                !apiDataUpdateEmandate.error?.error &&
                !apiDataUpdateSecEmandate.error?.error
            ) {
                this.props.history.push("declaration");
            }
        }
    };
    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        this.authKeeper = (this.context as AppContext)
            .authKeeper as Authorization;
        return (
            <>
                <div className="wrapper">
                    <HdfcHeader />

                    <section className="loan-wrap mt-110">
                        <div className="container mx-auto px-5">
                            <FormStep steps={this.steps} />

                            <h1 className="openSans-Reg text-black my-8 text-3xl md:text-3xl lg:text-3xl xl:text-4xl">
                                Application Form
                            </h1>

                            <form
                                onSubmit={(e) => this.handleOnSubmit(e)}
                                ref={this.formRef}
                                action="/aldd/save-emandate-channel"
                                method="POST"
                            >
                                <div className="w-full mb-4 md:mb-10">
                                    <h2 className="w-full openSans-Reg text-black text-lg md:text-2xl mb-5">
                                        You need to complete your NACH
                                        e-Mandate:
                                    </h2>
                                    <div className="text-left w-full mb-3">
                                        <label className="w-full custom-inputs inline-flex items-start mb-3">
                                            <input
                                                type="checkbox"
                                                onChange={() => {
                                                    this.setState({
                                                        iAgreeEMIRepayment: !this
                                                            .state
                                                            .iAgreeEMIRepayment,
                                                    });
                                                }}
                                                checked={
                                                    this.state
                                                        .iAgreeEMIRepayment
                                                }
                                            />
                                            <span></span>{" "}
                                            <span className="ml-2 text-sm md:text-base lg:text-xl text-black openSans-Reg">
                                                <a
                                                    onClick={() =>
                                                        this.setState({
                                                            iAgreeEMIRepaymentSwitch: true,
                                                        })
                                                    }
                                                    className="blue-link-color no-underline hover:underline hover:text-black transition-all openSans-SemiBold modal-open"
                                                    href="javascript:;"
                                                >
                                                    I agree to and accept and
                                                    issue the NACH e-Mandate
                                                </a>
                                            </span>{" "}
                                        </label>
                                        <span
                                            className={`${
                                                this.state
                                                    .iAgreeEMIRepaymentError
                                                    ? ""
                                                    : "hidden"
                                            } error-msg-relative text-red-600 openSans-Reg text-xs md:text-sm lg:text-sm xl:text-sm`}
                                        >
                                            Please check
                                        </span>{" "}
                                    </div>

                                    <div className="text-left w-full">
                                        <label className="w-full custom-inputs inline-flex items-start mb-3">
                                            <input
                                                type="checkbox"
                                                onChange={() => {
                                                    this.setState({
                                                        iAgreeSecurityMandate: !this
                                                            .state
                                                            .iAgreeSecurityMandate,
                                                    });
                                                }}
                                                checked={
                                                    this.state
                                                        .iAgreeSecurityMandate
                                                }
                                            />
                                            <span></span>{" "}
                                            <span className="ml-2 text-sm md:text-base lg:text-xl text-black openSans-Reg">
                                                <a
                                                    onClick={() =>
                                                        this.setState({
                                                            iAgreeSecurityMandateSwitch: true,
                                                        })
                                                    }
                                                    className="blue-link-color no-underline hover:underline hover:text-black transition-all openSans-SemiBold modal-open"
                                                    href="javascript:;"
                                                >
                                                    I agree to and accept the
                                                    NACH e-Mandate, which the
                                                    Bank may present at its
                                                    discretion, on any event of
                                                    default, from time to time.
                                                </a>{" "}
                                            </span>
                                        </label>
                                        <span
                                            className={`${
                                                this.state
                                                    .iAgreeSecurityMandateError
                                                    ? ""
                                                    : "hidden"
                                            } error-msg-relative text-red-600 openSans-Reg text-xs md:text-sm lg:text-sm xl:text-sm`}
                                        >
                                            Please check
                                        </span>{" "}
                                    </div>
                                </div>
                                <div className="w-full mb-4 md:mb-8">
                                    <h2 className="w-full openSans-Reg text-black text-lg md:text-2xl mb-3">
                                        Select e-Mandate Option
                                    </h2>
                                    <div className="w-full flex flex-wrap relative">
                                        <div className="custom-inputs w-full my-4 openSans-Reg text-black relative">
                                            {this.lead.bankNetBankingStatus ? (
                                                <RadioForm
                                                    label="Net Banking"
                                                    name="emandateChannel"
                                                    value="NET"
                                                    onChange={() => {}}
                                                />
                                            ) : (
                                                ""
                                            )}
                                            {this.lead.bankNetBankingStatus ? (
                                                <RadioForm
                                                    label="Debit Card"
                                                    name="emandateChannel"
                                                    value="DEBIT"
                                                    onChange={() => {}}
                                                />
                                            ) : (
                                                ""
                                            )}
                                            {this.lead.bankNetBankingStatus ? (
                                                <RadioForm
                                                    label="Aadhaar Card"
                                                    name="emandateChannel"
                                                    value="AADHAAR"
                                                    onChange={() => {}}
                                                />
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                        <span className="w-full hidden error-msg-relative text-red-600 openSans-Reg text-xs md:text-sm lg:text-sm xl:text-sm mb-4">
                                            Please check
                                        </span>
                                    </div>

                                    <p className="w-full text-sm md:text-base lg:text-xl text-black">
                                        You will be directed to mandate approval
                                        gateway of NPCI
                                    </p>
                                </div>
                                <input
                                    type="text"
                                    name="losAppId"
                                    value={this.lead.losAppId}
                                    hidden
                                />
                                <input
                                    type="text"
                                    name="leadId"
                                    value={this.lead.leadId}
                                    hidden
                                />
                                <input
                                    type="text"
                                    name="emandateChannel"
                                    value={this.lead.emandateChannel}
                                    hidden
                                />
                                <input
                                    type="text"
                                    name="authorization"
                                    value={this.authKeeper.authorization}
                                    hidden
                                />
                                <div className="w-full flex flex-wrap my-8">
                                    <button
                                        className="button-blue-bg text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue mb-2 mr-0 sm:mr-2 md:mr-2 lg:mr-3 xl:mr-4 transition-all"
                                        title="Proceed to e-Mandate"
                                    >
                                        Proceed to e-Mandate
                                    </button>
                                    <button
                                        className="bg-transparent border-2 button-blue-border blue-link-color hover:text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue button-white-blue mb-2 transition-all"
                                        title="Cancel"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    </section>

                    {/* <!-- Mandate Instruction Form for EMI Repayment popup Start --> */}
                    {this.state.iAgreeEMIRepaymentSwitch ? (
                        <ModalPopUp
                            onclickhandler={() =>
                                this.setState({
                                    iAgreeEMIRepaymentSwitch: false,
                                })
                            }
                        >
                            <IAgreeEMIRepayment
                                handleOnOTPSubmit={() =>
                                    this.setState({
                                        iAgreeEMIRepayment: true,
                                        iAgreeEMIRepaymentSwitch: false,
                                    })
                                }
                            />
                        </ModalPopUp>
                    ) : (
                        ""
                    )}
                    {/* <!-- Mandate Instruction Form for EMI Repayment popup End -->  */}
                    {/* <!-- Security Mandate Instruction popup Start --> */}
                    {this.state.iAgreeSecurityMandateSwitch ? (
                        <ModalPopUp
                            onclickhandler={() =>
                                this.setState({
                                    iAgreeSecurityMandateSwitch: false,
                                })
                            }
                        >
                            <IAgreeSecurityMandate
                                handleOnOTPSubmit={() =>
                                    this.setState({
                                        iAgreeSecurityMandate: true,
                                        iAgreeSecurityMandateSwitch: false,
                                    })
                                }
                            />
                        </ModalPopUp>
                    ) : (
                        ""
                    )}
                    {/* <!-- Security Mandate Instruction popup End -->  */}
                </div>
            </>
        );
    }
}

export default EMandate;
